import axios from "../http_v2";

import content from './content'

export default {
  personInfo() {
    return axios.get('opservice/tenant/current')
  },
  content,
  // 左侧菜单列表接口
  menuList: (params) => {
    return axios.get('opservice/tenant/security/current/menu/left', params)
  },
  uploadImg: 'https://mk-api.yybip.com/opservice/ophonoredguest/savefile',
  // post 例子
  postExample: (params) => {
    return axios.post('api_url', params)
  },
  // get 例子
  getExample: (params) => {
    return axios.get('api_url', params)
  },
  tdk: {
    save: (params) => {
      return axios.post('websitecenter/tdk/save', params)
    },
    get: (params) => {
      return axios.get('websitecenter/tdk/get', params)
    },
    del: (params) => {
      return axios.get('websitecenter/tdk/delete', params)
    },
    page: (params) => {
      return axios.post('websitecenter/tdk/page', params)
    },
  },
  type: {
    save: (params) => {
      return axios.post('websitecenter/typetree/save', params)
    },
    list: (params) => {
      return axios.get('websitecenter/typetree/get/tree', params)
    },
    del: (params) => {
      return axios.get('websitecenter/typetree/delete/id', params)
    }
  },
  website: {
    list: (params) => {
      return axios.post('websitecenter/website/page', params)
    },
    get: (params) => {
      return axios.get('websitecenter/website/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/website/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/website/delete', params)
    }
  },
  nav: {
    list: (params) => {
      return axios.get('websitecenter/menu/get/html/page', params)
    },
    get: (params) => {
      return axios.get('websitecenter/menu/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/menu/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/menu/delete/id', params)
    }
  },
  banner: {
    list: (params) => {
      return axios.post('websitecenter/picture/page', params)
    },
    get: (params) => {
      return axios.get('websitecenter/picture/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/picture/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/picture/delete', params)
    }
  },
  testimony: {
    list: (params) => {
      return axios.post('websitecenter/testimony/get/page', params)
    },
    del: (params) => {
      return axios.get('websitecenter/testimony/delete/id', params)
    },
    save: (params) => {
      return axios.post('websitecenter/testimony/save', params)
    },
 
  },
  product: {
    list: (params) => {
      return axios.post('websitecenter/product/page', params)
    },
    get: (params) => {
      return axios.get('websitecenter/product/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/product/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/product/delete', params)
    }
  },
  anli: {
    list: (params) => {
      return axios.post('websitecenter/customercase/page', params)
    },
    get: (params) => {
      return axios.get('websitecenter/customercase/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/customercase/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/customercase/delete', params)
    }
  },
  node: {
    list: (params) => {
      return axios.get('websitecenter/node/list', params)
    },
    get: (params) => {
      return axios.get('websitecenter/node/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/node/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/node/delete', params)
    }
  },
  hezuo: {
    list: (params) => {
      return axios.post('websitecenter/activitycustomer/page', params)
    },
    get: (params) => {
      return axios.get('websitecenter/activitycustomer/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/activitycustomer/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/activitycustomer/delete', params)
    }
  },
  active: {
    all: (params) => {
      return axios.post('activityservice/activitysearch/html/page', params)
    },
    list: (params) => {
      return axios.get('websitecenter/recommand/html/page', params)
    },
    save: (params) => {
      return axios.post('websitecenter/recommand/save', params)
    },
    del: (params) => {
      return axios.post('websitecenter/recommand/delete?id='+ params, {})
    }
  },
  solution: {
    list: (params) => {
      return axios.post('websitecenter/solution/page', params)
    },
    get: (params) => {
      return axios.get('websitecenter/solution/get', params)
    },
    save: (params) => {
      return axios.post('websitecenter/solution/save', params)
    },
    del: (params) => {
      return axios.get('websitecenter/solution/delete', params)
    }
  }
}